import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import SVG from 'react-inlinesvg';

export default function IntercomButton({ intercomData }) {
  return (
    <IconWrapper
      onClick={() => {
        window.Intercom('update', intercomData);
        window.Intercom('show');
      }}
      data-tip="Ask Us"
      data-for="IntercomButton"
    >
      <i className="fa-regular fa-comment fa-flip-horizontal fa-xl"></i>
    </IconWrapper>
  );
}

const IconWrapper = styled.div`
  display: none;

  ${themeGet('mediaQueries.forMediumUp')} {
    display: block;
    cursor: pointer;
    margin: 0 28px;
    &:hover {
      .fa-comment {
        color: ${themeGet('colors.black.60')};
      }
    }
  }
`;
